import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "osp-panel" }
const _hoisted_2 = {
  key: 0,
  class: "osp-body"
}
const _hoisted_3 = { class: "osp-detail-header" }
const _hoisted_4 = { class: "osp-detail-title" }
const _hoisted_5 = { class: "osp-detail-meta" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "osp-item-actions"
}
const _hoisted_9 = {
  key: 0,
  class: "osp-lineage"
}
const _hoisted_10 = { class: "osp-item-title" }
const _hoisted_11 = { class: "osp-item-desc" }
const _hoisted_12 = { class: "osp-lineage-actions" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "osp-new-form"
}
const _hoisted_16 = { class: "osp-grid" }
const _hoisted_17 = { class: "osp-field" }
const _hoisted_18 = { class: "osp-field" }
const _hoisted_19 = {
  key: 0,
  class: "osp-error"
}
const _hoisted_20 = { class: "osp-actions" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 2,
  class: "osp-new-form"
}
const _hoisted_23 = { class: "osp-grid" }
const _hoisted_24 = { class: "osp-field osp-field-wide" }
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "osp-chips"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "osp-field" }
const _hoisted_29 = { class: "osp-field osp-field-wide" }
const _hoisted_30 = { class: "osp-check-row" }
const _hoisted_31 = {
  key: 0,
  class: "osp-error"
}
const _hoisted_32 = {
  key: 1,
  class: "osp-success"
}
const _hoisted_33 = { class: "osp-actions" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "osp-items" }
const _hoisted_36 = { class: "osp-item-top" }
const _hoisted_37 = { class: "osp-item-title" }
const _hoisted_38 = {
  key: 0,
  class: "osp-item-desc"
}
const _hoisted_39 = {
  key: 0,
  class: "osp-item-evidence"
}
const _hoisted_40 = {
  key: 0,
  class: "osp-evidence-line"
}
const _hoisted_41 = {
  key: 1,
  class: "osp-evidence-line"
}
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 3,
  class: "osp-evidence-meta"
}
const _hoisted_44 = {
  key: 1,
  class: "osp-review-note"
}
const _hoisted_45 = {
  key: 2,
  class: "osp-item-actions"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 3,
  class: "osp-reject-form"
}
const _hoisted_49 = { class: "osp-item-actions" }
const _hoisted_50 = ["disabled", "onClick"]
const _hoisted_51 = {
  key: 1,
  class: "osp-body"
}
const _hoisted_52 = {
  key: 0,
  class: "osp-form"
}
const _hoisted_53 = {
  key: 0,
  class: "osp-new-form"
}
const _hoisted_54 = { class: "osp-grid" }
const _hoisted_55 = { class: "osp-field osp-field-wide" }
const _hoisted_56 = { class: "osp-field" }
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "osp-field" }
const _hoisted_59 = { class: "osp-field" }
const _hoisted_60 = { class: "osp-field osp-field-wide" }
const _hoisted_61 = { class: "osp-field osp-field-wide" }
const _hoisted_62 = ["value"]
const _hoisted_63 = {
  key: 0,
  class: "osp-chips"
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "osp-items-form" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 0,
  class: "osp-error"
}
const _hoisted_70 = { class: "osp-actions" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { class: "osp-filters" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "osp-page-size" }
const _hoisted_75 = {
  key: 1,
  class: "osp-loading"
}
const _hoisted_76 = {
  key: 2,
  class: "osp-empty"
}
const _hoisted_77 = { class: "osp-list" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "osp-os-card-top" }
const _hoisted_80 = { class: "osp-item-title" }
const _hoisted_81 = { class: "osp-item-desc" }
const _hoisted_82 = { class: "osp-progress" }
const _hoisted_83 = { class: "osp-progress-bar" }
const _hoisted_84 = {
  key: 0,
  class: "osp-pagination"
}
const _hoisted_85 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "osp-header" }, [
      _createElementVNode("h2", { class: "osp-title" }, "Gerenciar Ordens de Serviço"),
      _createElementVNode("p", { class: "osp-subtitle" }, "Uma OS é um grupo de rotinas — designe várias de uma vez para 1 ou mais responsáveis.")
    ], -1)),
    (_ctx.selected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "osp-back",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selected = null))
          }, [...(_cache[32] || (_cache[32] = [
            _createElementVNode("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
            ], -1),
            _createTextVNode(" Voltar ", -1)
          ]))]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, "OS" + _toDisplayString(_ctx.selected.osNumber) + " — " + _toDisplayString(_ctx.selected.title), 1),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.selected.projectName) + " · " + _toDisplayString(_ctx.selected.responsaveis.join(', ')) + " ", 1),
                (_ctx.selected.dueDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · prazo " + _toDisplayString(_ctx.formatDate(_ctx.selected.dueDate)), 1))
                  : _createCommentVNode("", true),
                (_ctx.selected.requireAll)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " · todos precisam preencher"))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(["osp-priority-badge", 'p-' + _ctx.selected.priority])
                }, _toDisplayString(_ctx.priorityLabel(_ctx.selected.priority)), 3),
                _createElementVNode("span", {
                  class: _normalizeClass(["osp-status-badge", 's-' + _ctx.selected.status])
                }, _toDisplayString(_ctx.statusLabel(_ctx.selected.status)), 3)
              ])
            ]),
            (_ctx.accessLevel >= 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.selected.status !== 'cancelled')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          class: "osp-btn",
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddItem = !_ctx.showAddItem))
                        }, "+ Adicionar rotina"),
                        _createElementVNode("button", {
                          class: "osp-btn",
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDesignate = !_ctx.showDesignate))
                        }, "Designar OS"),
                        _createElementVNode("button", {
                          class: "osp-btn osp-btn-danger",
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelOs && _ctx.cancelOs(...args)))
                        }, "Cancelar OS")
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.accessLevel >= 3)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "osp-btn osp-btn-danger",
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteOs(_ctx.selected.id)))
                      }, "Apagar OS"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.lineage.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "osp-section-label" }, "Designações desta OS", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineage, (os) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: os.id,
                    class: _normalizeClass(["osp-lineage-item", { current: os.id === _ctx.selected.id }])
                  }, [
                    _createElementVNode("span", _hoisted_10, "OS" + _toDisplayString(os.osNumber), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["osp-status-badge", 's-' + os.status])
                    }, _toDisplayString(_ctx.statusLabel(os.status)), 3),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(os.responsaveis.join(', ')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      (os.id !== _ctx.selected.id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "osp-btn",
                            type: "button",
                            onClick: ($event: any) => (_ctx.openDetail(os))
                          }, "Ver", 8, _hoisted_13))
                        : _createCommentVNode("", true),
                      (_ctx.accessLevel >= 3)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "osp-btn osp-btn-danger",
                            type: "button",
                            onClick: ($event: any) => (_ctx.deleteOs(os.id))
                          }, "Apagar", 8, _hoisted_14))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.showAddItem)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", { class: "osp-label" }, "Título da rotina", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "osp-input",
                      type: "text",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newItem.title) = $event)),
                      placeholder: "Ex.: Verificar extintores"
                    }, null, 512), [
                      [_vModelText, _ctx.newItem.title]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "osp-label" }, "Descrição (opcional)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "osp-input",
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newItem.description) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.newItem.description]
                    ])
                  ])
                ]),
                (_ctx.addItemError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.addItemError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "osp-btn osp-btn-primary",
                    type: "button",
                    disabled: _ctx.addingItem,
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitAddItem && _ctx.submitAddItem(...args)))
                  }, _toDisplayString(_ctx.addingItem ? 'Adicionando...' : 'Adicionar rotina'), 9, _hoisted_21)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showDesignate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "osp-section-label" }, "Designar esta OS a novo(s) responsável(is)", -1)),
                _cache[41] || (_cache[41] = _createElementVNode("p", { class: "osp-hint" }, "Cria uma OS numerada nova (mesmas rotinas, pendentes de novo) para o(s) responsável(is) escolhido(s), sem apagar o histórico desta.", -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "osp-label" }, "Responsáveis", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "osp-select",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.designatePick) = $event)),
                      onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addDesignateResponsavel && _ctx.addDesignateResponsavel(...args)))
                    }, [
                      _cache[36] || (_cache[36] = _createElementVNode("option", { value: "" }, "— Adicionar responsável —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOptions, (u) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: u.username,
                          value: u.username
                        }, _toDisplayString(u.name), 9, _hoisted_25))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.designatePick]
                    ]),
                    (_ctx.designateForm.responsavelUserIds.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designateForm.responsavelUserIds, (uid) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: uid,
                              class: "osp-chip"
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.userNameOf(uid)) + " ", 1),
                              _createElementVNode("button", {
                                class: "osp-chip-x",
                                type: "button",
                                onClick: ($event: any) => (_ctx.removeDesignateResponsavel(uid))
                              }, "×", 8, _hoisted_27)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "osp-label" }, "Prazo", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "osp-input",
                      type: "date",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.designateForm.dueDate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.designateForm.dueDate]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.designateForm.requireAll) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.designateForm.requireAll]
                      ]),
                      _cache[39] || (_cache[39] = _createTextVNode(" Todos precisam preencher (cria uma OS separada por pessoa, em vez de compartilhada) ", -1))
                    ])
                  ])
                ]),
                (_ctx.designateError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.designateError), 1))
                  : _createCommentVNode("", true),
                (_ctx.designateResult)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.designateResult), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    class: "osp-btn osp-btn-primary",
                    type: "button",
                    disabled: _ctx.designating,
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.submitDesignate && _ctx.submitDesignate(...args)))
                  }, _toDisplayString(_ctx.designating ? 'Designando...' : 'Designar OS'), 9, _hoisted_34)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "osp-item-card"
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(item.title), 1),
                    (item.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(item.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["osp-status-badge", 's-' + item.status])
                  }, _toDisplayString(_ctx.itemStatusLabel(item.status)), 3)
                ]),
                (item.status !== 'pending' || item.completedAt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      (item.textResponse)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(item.textResponse), 1))
                        : _createCommentVNode("", true),
                      (item.checkResponse)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, "✓ Marcado como feito"))
                        : _createCommentVNode("", true),
                      (item.photoResponse)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            src: item.photoResponse,
                            class: "osp-evidence-photo",
                            alt: "Evidência"
                          }, null, 8, _hoisted_42))
                        : _createCommentVNode("", true),
                      (item.completedByName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Concluído por " + _toDisplayString(item.completedByName) + " em " + _toDisplayString(_ctx.formatDateTime(item.completedAt)), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (item.reviewNotes && item.status === 'pending')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Reprovado por " + _toDisplayString(item.reviewedByName) + ": " + _toDisplayString(item.reviewNotes), 1))
                  : _createCommentVNode("", true),
                (_ctx.accessLevel >= 3 && item.status === 'done')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("button", {
                        class: "osp-btn osp-btn-primary",
                        type: "button",
                        onClick: ($event: any) => (_ctx.approve(item.id))
                      }, "Aprovar", 8, _hoisted_46),
                      _createElementVNode("button", {
                        class: "osp-btn osp-btn-danger",
                        type: "button",
                        onClick: ($event: any) => (_ctx.openReject(item.id))
                      }, "Reprovar", 8, _hoisted_47)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.rejecting === item.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "osp-textarea",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rejectNotes) = $event)),
                        rows: "2",
                        placeholder: "Motivo da reprovação (obrigatório)"
                      }, null, 512), [
                        [_vModelText, _ctx.rejectNotes]
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("button", {
                          class: "osp-btn",
                          type: "button",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.rejecting = ''))
                        }, "Cancelar"),
                        _createElementVNode("button", {
                          class: "osp-btn osp-btn-danger",
                          type: "button",
                          disabled: !_ctx.rejectNotes.trim(),
                          onClick: ($event: any) => (_ctx.reject(item.id))
                        }, "Confirmar reprovação", 8, _hoisted_50)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_51, [
          (_ctx.accessLevel >= 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("button", {
                  class: "osp-btn osp-btn-primary",
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showForm = !_ctx.showForm))
                }, _toDisplayString(_ctx.showForm ? 'Fechar formulário' : '+ Nova Ordem de Serviço'), 1),
                (_ctx.showForm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _cache[42] || (_cache[42] = _createElementVNode("label", { class: "osp-label" }, "Título da OS", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "osp-input",
                            type: "text",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.title) = $event)),
                            placeholder: "Ex.: Manutenção elétrica — bloco B"
                          }, null, 512), [
                            [_vModelText, _ctx.form.title]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _cache[44] || (_cache[44] = _createElementVNode("label", { class: "osp-label" }, "Projeto", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "osp-select",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.projectId) = $event))
                          }, [
                            _cache[43] || (_cache[43] = _createElementVNode("option", { value: "" }, "— Selecione —", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: p.id,
                                value: p.id
                              }, _toDisplayString(p.name), 9, _hoisted_57))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.form.projectId]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _cache[46] || (_cache[46] = _createElementVNode("label", { class: "osp-label" }, "Prioridade", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "osp-select",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.priority) = $event))
                          }, [...(_cache[45] || (_cache[45] = [
                            _createElementVNode("option", { value: "baixa" }, "Baixa", -1),
                            _createElementVNode("option", { value: "normal" }, "Normal", -1),
                            _createElementVNode("option", { value: "alta" }, "Alta", -1),
                            _createElementVNode("option", { value: "urgente" }, "Urgente", -1)
                          ]))], 512), [
                            [_vModelSelect, _ctx.form.priority]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _cache[47] || (_cache[47] = _createElementVNode("label", { class: "osp-label" }, "Prazo", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "osp-input",
                            type: "date",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.dueDate) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.form.dueDate]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _cache[48] || (_cache[48] = _createElementVNode("label", { class: "osp-label" }, "Descrição", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: "osp-textarea",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.description) = $event)),
                            rows: "2"
                          }, null, 512), [
                            [_vModelText, _ctx.form.description]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _cache[50] || (_cache[50] = _createElementVNode("label", { class: "osp-label" }, [
                            _createTextVNode("Responsáveis "),
                            _createElementVNode("span", { class: "osp-hint" }, "— o primeiro que concluir um item já vale para todos")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "osp-select",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.respPick) = $event)),
                            onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addResponsavel && _ctx.addResponsavel(...args)))
                          }, [
                            _cache[49] || (_cache[49] = _createElementVNode("option", { value: "" }, "— Adicionar responsável —", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOptions, (u) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: u.username,
                                value: u.username
                              }, _toDisplayString(u.name), 9, _hoisted_62))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.respPick]
                          ]),
                          (_ctx.form.responsavelUserIds.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.responsavelUserIds, (uid) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: uid,
                                    class: "osp-chip"
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.userNameOf(uid)) + " ", 1),
                                    _createElementVNode("button", {
                                      class: "osp-chip-x",
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.removeResponsavel(uid))
                                    }, "×", 8, _hoisted_64)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "osp-section-label" }, "Rotinas desta OS", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.items, (item, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: "osp-item-row"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "osp-input",
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                              placeholder: "Título da rotina"
                            }, null, 8, _hoisted_66), [
                              [_vModelText, item.title]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              class: "osp-input",
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                              placeholder: "Descrição (opcional)"
                            }, null, 8, _hoisted_67), [
                              [_vModelText, item.description]
                            ]),
                            _createElementVNode("button", {
                              class: "osp-chip-x",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeItem(idx))
                            }, "×", 8, _hoisted_68)
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          class: "osp-btn",
                          type: "button",
                          onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
                        }, "+ Adicionar rotina")
                      ]),
                      (_ctx.error)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(_ctx.error), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("button", {
                          class: "osp-btn osp-btn-primary",
                          type: "button",
                          disabled: _ctx.saving,
                          onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                        }, _toDisplayString(_ctx.saving ? 'Criando...' : 'Criar OS'), 9, _hoisted_71)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_72, [
            _withDirectives(_createElementVNode("select", {
              class: "osp-select",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.filters.projectId) = $event)),
              onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, [
              _cache[52] || (_cache[52] = _createElementVNode("option", { value: "" }, "Todos os projetos", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: p.id,
                  value: p.id
                }, _toDisplayString(p.name), 9, _hoisted_73))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.filters.projectId]
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "osp-select",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.filters.status) = $event)),
              onChange: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, [...(_cache[53] || (_cache[53] = [
              _createElementVNode("option", { value: "" }, "Todos os status", -1),
              _createElementVNode("option", { value: "pending" }, "Em andamento", -1),
              _createElementVNode("option", { value: "approved" }, "Aprovadas", -1),
              _createElementVNode("option", { value: "cancelled" }, "Canceladas", -1)
            ]))], 544), [
              [_vModelSelect, _ctx.filters.status]
            ]),
            _createElementVNode("label", _hoisted_74, [
              _cache[55] || (_cache[55] = _createTextVNode(" Exibir: ", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "osp-select",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.pageSize) = $event)),
                onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.currentPage = 1))
              }, [...(_cache[54] || (_cache[54] = [
                _createElementVNode("option", { value: 10 }, "10", -1),
                _createElementVNode("option", { value: 25 }, "25", -1),
                _createElementVNode("option", { value: 50 }, "50", -1),
                _createElementVNode("option", { value: 100 }, "100", -1)
              ]))], 544), [
                [
                  _vModelSelect,
                  _ctx.pageSize,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            (_ctx.accessLevel >= 3)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "osp-btn osp-btn-primary",
                  type: "button",
                  onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.exportExcel && _ctx.exportExcel(...args)))
                }, "Exportar Excel"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, "Carregando..."))
            : (_ctx.orders.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, "Nenhuma OS encontrada."))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_77, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedOrders, (os) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: os.id,
                        class: "osp-os-card",
                        type: "button",
                        onClick: ($event: any) => (_ctx.openDetail(os))
                      }, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("span", _hoisted_80, "OS" + _toDisplayString(os.osNumber) + " — " + _toDisplayString(os.title), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["osp-status-badge", 's-' + os.status])
                          }, _toDisplayString(_ctx.statusLabel(os.status)), 3)
                        ]),
                        _createElementVNode("div", _hoisted_81, _toDisplayString(os.projectName) + " · " + _toDisplayString(os.responsaveis.join(', ')), 1),
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", {
                              class: "osp-progress-fill",
                              style: _normalizeStyle({ width: _ctx.progressPct(os) + '%' })
                            }, null, 4)
                          ]),
                          _createElementVNode("span", null, _toDisplayString(os.itemsApproved) + "/" + _toDisplayString(os.itemsTotal) + " itens aprovados", 1)
                        ])
                      ], 8, _hoisted_78))
                    }), 128))
                  ]),
                  (_ctx.totalPages > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (p) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: p,
                            class: _normalizeClass(["osp-page-btn", { active: p === _ctx.currentPage }]),
                            type: "button",
                            onClick: ($event: any) => (_ctx.currentPage = p)
                          }, _toDisplayString(p), 11, _hoisted_85))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
        ]))
  ]))
}